module.exports = __webpack_public_path__ + "static/media/m10tj538.1a787bb3.png";